import { render, staticRenderFns } from "./ExpandableCard.vue?vue&type=template&id=497e181a&scoped=true&"
import script from "./ExpandableCard.vue?vue&type=script&lang=ts&"
export * from "./ExpandableCard.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandableCard.vue?vue&type=style&index=0&id=497e181a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497e181a",
  null
  
)

export default component.exports